module.exports = __webpack_public_path__ + "img/VPS-sunich.4da8d4f.jpg";